// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"5706a65a","787":"a6af7229"}[chunkId] + ".chunk.js";
};